import _ from 'lodash';

const rts = {
  handleGet_mediaFeeds: 'handleGet_mediaFeeds',
  handleSet_rssFeeds: 'handleSet_rssFeeds',
  handleSet_rssFeedsNone: 'handleSet_rssFeedsNone',
}

export const rssReducer = (state, action) => {

  const { fns_fetch, mainFunctions, altFunctions } = state
  const { type, dispatch, rssFeeds_home, rssFeeds, rssFeed, titleSearch, contentSearch } = action

  switch (type) {

    case rts.handleGet_mediaFeeds:
      // getDbMediaFeeds(rssFeeds_home, rssFeeds, rssFeed, titleSearch, contentSearch, handleSet_rssFeeds, handleSet_rssFeedsNone)
      return { ...state }

    case rts.handleSet_rssFeeds:
      const _mediaFeeds = []
      if (action.mediaFeeds) {
        _.forEach(action.mediaFeeds, (mf) => {
          const _mf = _.pick(mf,
            [
              'content',
              'creator',
              'description',
              'enclosure',
              'link',
              'media_content',
              'pubDate',
              'source',
              'title',
            ])
          const _itemKey = generateFeedKey(_mf)
          _mediaFeeds.push({
            ..._mf,
            _itemKey
          })
        })
      }
      // database_fns, parentDataKeys, pathViews, sportsKey, _sportsYearAbr, mediaFeeds
      // updateMediaFeed(database_fns, parentDataKeys, pathViews, sportsKey, _sportsYearAbr, _mediaFeeds)
      return { ...state, mediaFeeds: _mediaFeeds }

    case rts.handleSet_rssFeedsNone:
      return { ...state, mediaFeedMessage: action.message }

    default:
      return { ...state }
  }
}

export const rssInitialState = (initState) => {
  return { ...initState }
};

export const rssHandlers = (dispatch) => {
  return {
    handleSet_rssFeeds: (mediaFeeds) => { dispatch({ type: rts.handleSet_rssFeeds, dispatch, mediaFeeds }) },
    handleSet_rssFeedsNone: (message) => { dispatch({ type: rts.handleSet_rssFeedsNone, dispatch, message }) },
  }
}

const generateFeedKey = (feed) => {
  const { link, title } = feed;
  const baseKey = _.kebabCase(`${link}-${title}`).replace(/[/.$#[\]]/g, "-");
  return baseKey
};
